
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// RPG Theme Utilities
export const getRpgThemeClasses = (enableRpgMode: boolean, darkMode: boolean) => {
  if (!enableRpgMode) return {};
  
  return {
    background: darkMode 
      ? "bg-gradient-to-br from-amber-900/20 via-purple-900/30 to-amber-800/20" 
      : "bg-gradient-to-br from-amber-50 via-purple-50 to-amber-100",
    cardBackground: darkMode
      ? "bg-amber-900/30 border-amber-600/40"
      : "bg-amber-100/80 border-amber-400/50",
    text: darkMode ? "text-amber-100" : "text-amber-900",
    accent: darkMode ? "text-amber-300" : "text-amber-700",
    button: "bg-amber-600 hover:bg-amber-700 text-white border border-amber-500/50 shadow-lg",
    decorative: "font-montserrat drop-shadow-md"
  };
};

export const getRpgTerminology = (term: string): string => {
  const rpgTerms: Record<string, string> = {
    'Dashboard': 'Adventure Hub',
    'Create New Entry': 'Begin New Quest',
    'View History': 'Chronicle of Adventures',
    'Total Entries': 'Completed Quests',
    'Unstuck Rate': 'Success Rate',
    'This Week': 'Recent Adventures',
    'Journal History': 'Chronicle of Quests',
    'New Entry': 'New Quest',
    'entries': 'quests',
    'entry': 'quest',
    'Journal': 'Quest Journal',
    'Settings': 'Adventurer Preferences'
  };
  
  return rpgTerms[term] || term;
};
